import { useParams, Link } from 'react-router-dom';
import { usePublicUser } from '../../../api/organizations';
import { UserRole } from '@spi/shared';
import { UserIcon, OrgIcon, DonorIcon, RecipientIcon } from '../shared/EntityIcons';
import { PageMeta } from '../shared/PageMeta';

export function UserPage() {
  const { id } = useParams();
  const userId = parseInt(id || '0', 10);
  const { data: profile, isLoading } = usePublicUser(userId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
      </div>
    );
  }

  if (!profile) {
    return <div className="container mx-auto px-4 py-16 text-center"><h2 className="text-2xl">User Not Found</h2></div>;
  }

  const fullName = `${profile.firstName} ${profile.lastName}`;
  const RoleIcon = profile.role === UserRole.DONOR ? DonorIcon : RecipientIcon;
  const roleBadgeColor = profile.role === UserRole.DONOR ? 'bg-violet-100 text-violet-700' : 'bg-emerald-100 text-emerald-700';

  return (
    <div className="container mx-auto px-4 py-8">
      <PageMeta title={fullName} description={`${fullName} profile`} path={`/marketplace/users/${profile.id}`} />

      <Link to="/marketplace/projects" className="text-sm text-spi-green hover:underline mb-4 inline-block">&larr; Back</Link>

      {/* Header card */}
      <div className="card p-8 mb-6">
        <h2 className="text-2xl mb-1 flex items-center gap-2">
          <UserIcon className="w-6 h-6 text-spi-slate" />
          {fullName}
        </h2>
        <div className="flex flex-wrap items-center gap-2 mt-2">
          <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${roleBadgeColor} capitalize`}>
            <RoleIcon className="w-3 h-3" />
            {profile.role}
          </span>
          <span className="text-sm text-spi-slate">
            Member since {new Date(profile.createdAt).toLocaleDateString()}
          </span>
        </div>
      </div>

      {/* Organization section */}
      {profile.organization && (
        <div className="card p-8">
          <h3 className="text-lg font-semibold mb-3">Organization</h3>
          <div className="flex items-center gap-2">
            <OrgIcon className="w-5 h-5 text-spi-green" />
            <Link to={`/marketplace/organizations/${profile.organization.id}`} className="text-spi-green hover:underline font-medium">
              {profile.organization.name}
            </Link>
          </div>
          <div className="flex flex-wrap gap-3 mt-2 text-sm text-spi-slate">
            <span className="capitalize">{profile.organization.type}</span>
            <span>{profile.organization.country}</span>
          </div>
        </div>
      )}
    </div>
  );
}
